/**
 * Created by bartdecorte on 12/05/2017.
 */
import EntriesAssets from './EntriesAssets';
import {imageRules} from '../../helpers/validation_helper';

class EntriesImages extends EntriesAssets {
  constructor() {
    const dropzoneParams = {
      fileRules: imageRules(),
      type: 'image',
    };
    super(dropzoneParams);
    this.bindKeys(this.keyBindings());
  }

  bindListeners() {
    this.itemEls().forEach((el) => {
      el.addEventListener('click', ev => this.lThumbClicked(ev));
    });
    super.bindListeners();
  }

  lThumbClicked(ev) {
    ev.preventDefault();
    this.propagateToCkEditor(ev.target.dataset.url);
    return false;
  }

  itemEls() {
    return [...this.rootEl.querySelectorAll('.js-gallery-item')];
  }
}

export default EntriesImages;



// WEBPACK FOOTER //
// ./resources/assets/js/pages/Entries/EntriesImages.js